import createVueApp from '@phoenix/createVueApp';
import Panel from '@maison/components/common/Panel.vue';
import CurrentCountry from '@phoenix/components/CurrentCountry';

document.querySelectorAll('.phoenix-panel').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('Panel', Panel);
  app.mount(el);
  if (window.currentCountry) {
    // This is needed as the component seems to mount before the reveal has happened, so vue keep the wrong dom
    const currentCountry = window.currentCountry;
    const items = el.querySelectorAll(CurrentCountry.COUNTRY_REVEAL_CONTAINER);
    const currentCountryCode = window.Phoenix.currentCountry;

    if (!items || !currentCountryCode || currentCountryCode === '') {
      return;
    }

    Array.from(items).forEach((container) => {
      currentCountry.revealCountryForElement(currentCountryCode, container);
    });
  }
});
